// import { useContext, useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { SidebarContext } from "context/SidebarContext";
// import AirportServices from "services/AirportServices";
// import { notifyError, notifySuccess } from "utils/toast";

// const useAirportSubmit = (id) => {

//   const { isDrawerOpen, closeDrawer, setIsUpdate } =
//     useContext(SidebarContext);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const {
//     register,
//     handleSubmit,
//     setValue,
//     clearErrors,
//     formState: { errors },
//   } = useForm();

//   const onSubmit = async (data) => {
//     setLoading(true);
//     try {

//       setIsSubmitting(true);
//       const CityData = {
//         airportname:data.airportname,
//         parking: Number(data.parking),
//         id_city: selectedCity,
//         airportcode: data.airportcode,
//         countrycode:  "IN",
//         countryname: "India",
//       };

//       if (id) {
//         const res = await AirportServices.updateAirport(id, CityData);
//         setIsUpdate(true);
//         setIsSubmitting(false);
//         notifySuccess(res.message);
//         closeDrawer();
//       } else {
//         const res = await AirportServices.addAirport( CityData );
//         setIsUpdate(true);
//         setIsSubmitting(false);
//         notifySuccess(res.message);
//         closeDrawer();
//       }
//     } catch (err) {
//       notifyError(err ? err?.response?.data?.message : err?.message);
//       setIsSubmitting(false);
//     //  closeDrawer();
//     }
//     finally{
//       setLoading(false);
//     }
//   };

//   const getCityData = async () => {
//     try {
//       const res = await AirportServices.getAirportById(id);
//       if (res) {
//         setValue("airportname",res.airportname);
//         setValue("parking",res.parking);
//       setValue("citycode",res.citycode);
//       setValue("airportcode",res.airportcode);
//       setSelectedCity(res.id_city);
//       }
//     } catch (err) {
//       notifyError(err ? err?.response?.data?.message : err?.message);
//     }
//   };

//   useEffect(() => {
//     if (!isDrawerOpen) {
//       setValue("airportname");
//       setValue("parking");
//       setValue("airportcode");
//       setSelectedCity("");
//       clearErrors();
//       return;
//     }

//     if (id) {
//       getCityData();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id, setValue, isDrawerOpen, clearErrors]);

//   return {
//     register,
//     handleSubmit,
//     onSubmit, loading,
//     setLoading,
//     errors,
//     isSubmitting,
//     setValue,
//     selectedCity, setSelectedCity
//   };
// };

// export default useAirportSubmit;

// import { useContext, useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { SidebarContext } from "context/SidebarContext";
// import AirportServices from "services/AirportServices";
// import { notifyError, notifySuccess } from "utils/toast";

// const useAirportSubmit = (id) => {

//   const { isDrawerOpen, closeDrawer, setIsUpdate } =
//     useContext(SidebarContext);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [selectedCity, setSelectedCity] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const {
//     register,
//     handleSubmit,
//     setValue,
//     clearErrors,
//     formState: { errors },
//   } = useForm();

//   const onSubmit = async (data) => {
//     setLoading(true);
//     try {

//       setIsSubmitting(true);
//       const CityData = {
//         airportname:data.airportname,
//         parking: Number(data.parking),
//         id_city: selectedCity,
//         airportcode: data.airportcode,
//         countrycode:  "IN",
//         countryname: "India",
//       };

//       if (id) {
//         const res = await AirportServices.updateAirport(id, CityData);
//         setIsUpdate(true);
//         setIsSubmitting(false);
//         notifySuccess(res.message);
//         closeDrawer();
//       } else {
//         const res = await AirportServices.addAirport( CityData );
//         setIsUpdate(true);
//         setIsSubmitting(false);
//         notifySuccess(res.message);
//         closeDrawer();
//       }
//     } catch (err) {
//       notifyError(err ? err?.response?.data?.message : err?.message);
//       setIsSubmitting(false);
//     //  closeDrawer();
//     }
//     finally{
//       setLoading(false);
//     }
//   };

//   const getCityData = async () => {
//     try {
//       const res = await AirportServices.getAirportById(id);
//       if (res) {
//         setValue("airportname",res.airportname);
//         setValue("parking",res.parking);
//       setValue("citycode",res.citycode);
//       setValue("airportcode",res.airportcode);
//       setSelectedCity(res.id_city);
//       }
//     } catch (err) {
//       notifyError(err ? err?.response?.data?.message : err?.message);
//     }
//   };

//   useEffect(() => {
//     if (!isDrawerOpen) {
//       setValue("airportname");
//       setValue("parking");
//       setValue("airportcode");
//       setSelectedCity("");
//       clearErrors();
//       return;
//     }

//     if (id) {
//       getCityData();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [id, setValue, isDrawerOpen, clearErrors]);

//   return {
//     register,
//     handleSubmit,
//     onSubmit, loading,
//     setLoading,
//     errors,
//     isSubmitting,
//     setValue,
//     selectedCity, setSelectedCity
//   };
// };

// export default useAirportSubmit;

import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import AirportServices from "services/AirportServices";
import { notifyError, notifySuccess } from "utils/toast";

const defaultValues = {
  airportname: "",
  airportcode: "",
  citycode: "",
  parking: {},
  latitude: "",
  longitude: "",
};

const useAirportSubmit = (id) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);

  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const clearForm = () => {
    reset(defaultValues);

    setSelectedCity(null);

    clearErrors();

    setValue("airportname", "");
    setValue("airportcode", "");
    setValue("latitude", "");
    setValue("longitude", "");
    setValue("citycode", "");
    setValue("parking", {});
  };

  const onSubmit = async (data) => {
    setLoading(true);
    setIsSubmitting(true);

    try {
      const parkingData = Object.entries(data.parking || {}).reduce(
        (acc, [key, value]) => {
          if (
            value !== "" &&
            value !== undefined &&
            value !== null &&
            !isNaN(Number(value))
          ) {
            acc[key] = Number(value);
          }
          return acc;
        },
        {},
      );

      const payload = {
        airportname: data.airportname,
        airportcode: data.airportcode,
        latitude: data.latitude,
        longitude: data.longitude,
        id_city: selectedCity,
        parking: parkingData,
        countrycode: "IN",
        countryname: "India",
      };

      let res;

      if (id) {
        res = await AirportServices.updateAirport(id, payload);
      } else {
        res = await AirportServices.addAirport(payload);
      }

      notifySuccess(res.message);

      setIsUpdate(true);

      clearForm();

      closeDrawer();
    } catch (err) {
      notifyError(
        err?.response?.data?.message || err?.message || "Something went wrong",
      );
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const getCityData = async () => {
    try {
      const res = await AirportServices.getAirportById(id);

      clearForm();

      setValue("airportname", res.airportname || "");
      setValue("airportcode", res.airportcode || "");
      setValue("citycode", res.citycode || "");
      setValue("latitude", res.latitude || "");
      setValue("longitude", res.longitude || "");
      setSelectedCity(res.id_city || null);

      if (res.parking) {
        Object.entries(res.parking).forEach(([vehicleId, fee]) => {
          setValue(`parking.${vehicleId}`, fee);
        });
      }
    } catch (err) {
      notifyError(
        err?.response?.data?.message || err?.message || "Something went wrong",
      );
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      clearForm();
      return;
    }

    if (id) {
      getCityData();
    } else {
      clearForm();
    }
  }, [id, isDrawerOpen]);

  return {
    register,
    handleSubmit,
    onSubmit,
    loading,
    setLoading,
    errors,
    isSubmitting,
    setValue,
    selectedCity,
    setSelectedCity,
  };
};

export default useAirportSubmit;
